import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { LoginSignupButtonsModule } from 'app/login-signup/login-signup-buttons.module';
import { NewAccountLoginModule } from 'app/login-signup/new-account/login/new-account-login.module';
import { FormLogoModule } from '../form-logo/form-logo.module';
import { ResetPasswordFormComponent } from './reset-password-form/reset-password-form.component';
import { ResetPasswordSuccessComponent } from './reset-password-success/reset-password-success.component';
import { ResetPasswordComponent } from './reset-password.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    FormLogoModule,
    LoginSignupButtonsModule,
    NewAccountLoginModule,
    PipesModule,
    TrackingModule,
    UiModule,
  ],
  exports: [ResetPasswordComponent],
  declarations: [
    ResetPasswordComponent,
    ResetPasswordFormComponent,
    ResetPasswordSuccessComponent,
  ],
})
export class ResetPasswordModule {}
